import { render, staticRenderFns } from "./mainBody.vue?vue&type=template&id=4d578861&"
import script from "./mainBody.vue?vue&type=script&lang=js&"
export * from "./mainBody.vue?vue&type=script&lang=js&"
import style0 from "./mainBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports